import React from 'react';

import { usePageTitle } from '@/__core/layout';
import { InventoryStockTransactionModule } from '@/modules/inventory';

export default function InventoryStockTransactionPage() {
  usePageTitle('Giao dịch tồn kho');
  return <InventoryStockTransactionModule />;
}